// Admin auth helpers — stores JWT in localStorage, attaches to fetch requests
const TOKEN_KEY = "dmm_admin_token";
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

// Wrapper around fetch that auto-attaches Bearer token and handles 401
export const authFetch = async (path, options = {}) => {
  const token = getAdminToken();
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  const resp = await fetch(`${API_URL}${path}`, { ...options, headers });
  if (resp.status === 401) {
    clearAdminToken();
    if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
      window.location.href = "/admin/login";
    }
  }
  return resp;
};

// Download a protected file as a blob and trigger browser download
export const authDownload = async (path, filename) => {
  const resp = await authFetch(path);
  if (!resp.ok) throw new Error(`Download failed (${resp.status})`);
  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
